import { createGlobalStyle, DefaultTheme } from 'styled-components';

export const GlobalStyles = createGlobalStyle<{ theme: DefaultTheme }>`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');

  body {
    font-family: 'Roboto', 'Segoe UI', 'Arial', sans-serif;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
    line-height: 1.6;
    transition: all 0.3s ease;
  }

  button {
    cursor: pointer;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.primaryColor};
    color: ${({ theme }) => theme.white};
    font-weight: 500;
    transition: background-color 0.3s;
  }

  button:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
  }

  button:disabled {
    background-color: ${({ theme }) => theme.lightGray};
    color: ${({ theme }) => theme.darkGray};
    cursor: not-allowed;
  }

  input {
    padding: 10px;
    border: 1px solid ${({ theme }) => theme.lightGray};
    border-radius: 4px;
    font-size: 16px;
    width: 100%;
    transition: border-color 0.3s;
    background-color: ${({ theme }) => theme.white};
    color: ${({ theme }) => theme.textColor};
  }

  input:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
  }

  /* Estilos da página 404 */
  .not-found-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    text-align: center;
    padding: 20px;
  }

  .not-found-container h1 {
    font-size: 120px;
    color: ${({ theme }) => theme.primaryColor};
    margin-bottom: 0;
  }

  .not-found-container h2 {
    font-size: 32px;
    margin-bottom: 16px;
  }

  .not-found-container p {
    margin-bottom: 24px;
    color: ${({ theme }) => theme.darkGray};
  }

  .back-button {
    display: inline-block;
    padding: 10px 20px;
    background-color: ${({ theme }) => theme.primaryColor};
    color: ${({ theme }) => theme.white};
    text-decoration: none;
    border-radius: 4px;
    font-weight: 500;
    transition: background-color 0.3s;
  }

  .back-button:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
  }
`;
